import {DBConfig, ObjectStoreMeta} from 'ngx-indexed-db';

export const objectStoresMetaImages: ObjectStoreMeta = {
  store: 'images',
    storeConfig: { keyPath: 'id', autoIncrement: false },
  storeSchema: [
    { name: 'base64', keypath: 'base64', options: { unique: false } },
    { name: 'isPdf', keypath: 'isPdf', options: { unique: false } },
    { name: 'id', keypath: 'id', options: { unique: true } }
  ]
};

export const objectStoresMetaAppState: ObjectStoreMeta = {
  store: 'app_state',
  storeConfig: { keyPath: 'id', autoIncrement: false },
  storeSchema: [
    { name: 'id', keypath: 'id', options: { unique: true } },
    { name: 'value', keypath: 'value', options: { unique: false } }
  ]
};

export const dbConfig: DBConfig  = {
  name: 'Capana',
  version: 2,
  objectStoresMeta: [objectStoresMetaImages, objectStoresMetaAppState]
};
